import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { countryValidationForm } from "../../utils/validationSchema";
import CountryForm from "./CountryForm";
import Form from "../../layouts/Form";

const CreateCountry = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(countryValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <CountryForm
        errors={errors}
        register={register}
      />
    </Form>
  );
};

export default CreateCountry;
